// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:host {
  display: block;
  width: 95%;
  margin-bottom: 10px;
}
:host .q-icon {
  font-style: normal;
  font-size: 12px;
}
:host .q-remove-icon::before {
  content: "❌";
}
:host .q-arrow-icon-button {
  float: left;
  margin: 4px 6px 4px 0;
  transform: rotate(90deg);
  transition: linear 0.25s transform;
  cursor: pointer;
}
:host .q-arrow-icon-button.q-collapsed {
  transform: rotate(0);
}
:host .q-arrow-icon::before {
  content: "▶";
}
:host .q-add-icon {
  color: #555;
}
:host .q-remove-button {
  color: #B3415D;
  width: 31px;
}
:host .q-switch-group, :host .q-button-group {
  font-family: "Lucida Grande", Tahoma, Verdana, sans-serif;
  overflow: hidden;
  padding-top: 10px;
  padding-bottom: 10px;
}
:host .q-switch-group {
  padding-left: 20px;
}
:host .q-button-group {
  padding-right: 20px;
}
:host .q-right-align {
  float: right;
}
:host .q-button {
  margin-left: 8px;
  padding: 0 8px;
  background-color: white;
}
:host .q-button:disabled {
  display: none;
}
:host .q-control-size {
  display: inline-block;
  vertical-align: top;
  padding-right: 10px;
}
:host .q-input-control, :host .q-operator-control, :host .q-field-control, :host .q-entity-control {
  display: inline-block;
  padding: 5px 8px;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  width: auto;
}
:host .q-input-control:disabled, :host .q-operator-control:disabled, :host .q-field-control:disabled, :host .q-entity-control:disabled {
  border-color: transparent;
}
:host .q-operator-control, :host .q-field-control, :host .q-entity-control, :host .q-input-control:not([type=checkbox]) {
  min-height: 32px;
  -webkit-appearance: none;
}
:host .q-switch-label, :host .q-button {
  float: left;
  margin-bottom: 0;
  font-size: 8px;
  line-height: 21px;
  font-weight: normal;
  text-align: center;
  text-shadow: none;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  font-family: "robotoregular";
}
:host .q-switch-label:hover, :host .q-button:hover {
  cursor: pointer;
  background-color: #F0F0F0;
}
:host .q-button {
  font-weight: 600 !important;
  text-transform: uppercase;
  font-stretch: normal;
  font-style: normal;
  line-height: normal !important;
  letter-spacing: normal !important;
  color: #282828 !important;
  border-radius: 3px !important;
  border: solid 1px #e5eaed !important;
  padding-bottom: 2px;
}
:host .q-switch-label {
  background-color: #e5eaed;
  padding: 0 8px;
  height: 21px;
  color: #81898c;
}
:host .q-switch-label-and {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}
:host .q-switch-label-or {
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}
:host .q-switch-radio {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  width: 1px;
  border: 0;
  overflow: hidden;
}
:host .q-switch-radio:checked + .q-switch-label {
  border: 1px solid rgb(97, 158, 215);
  background: #1873b1 !important;
  color: #ffffff;
}
:host .q-switch-radio:disabled + .q-switch-label {
  display: none;
}
:host .q-switch-radio:checked:disabled + .q-switch-label {
  display: initial;
  color: initial;
  cursor: default;
  border-color: transparent;
}
:host .q-invalid-ruleset {
  border: 1px solid rgba(179, 65, 93, 0.5) !important;
  background: rgba(179, 65, 93, 0.1) !important;
}
:host .q-empty-warning {
  color: rgb(141, 37, 46);
  text-align: center;
}
:host .q-ruleset {
  border: 1px solid #CCC;
}
:host .q-rule {
  border: 1px solid #CCC;
  background: white;
}
:host .q-transition {
  transition: all 0.1s ease-in-out;
}
:host .q-tree-container {
  width: 100%;
  transition: ease-in 0.25s max-height;
}
:host .q-tree-container.q-collapsed {
  max-height: 0 !important;
}
:host .q-tree {
  list-style: none;
  margin: 4px 0 2px;
}
:host .q-row {
  padding: 6px 8px;
  margin-top: 6px;
  border-radius: 3px;
  border: solid 1px #e5eaed;
  width: 90%;
  margin-left: 5%;
  margin-bottom: 10px;
}
:host .q-connector {
  position: relative;
}
:host .q-connector::before {
  top: -5px;
  border-width: 0 0 2px 2px;
}
:host .q-connector::after {
  border-width: 0 0 0 2px;
  top: 50%;
}
:host .q-connector::before, :host .q-connector::after {
  content: "";
  left: -12px;
  border-color: #CCC;
  border-style: solid;
  width: 9px;
  height: calc(50% + 6px);
  position: absolute;
}
:host .q-connector:last-child::after {
  content: none;
}
:host .q-inline-block-display {
  display: inline-block;
  vertical-align: top;
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/sem-query-builder/query-builder.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,cAAA;EACA,UAAA;EACA,mBAAA;AAEF;AAAE;EACE,kBAAA;EACA,eAAA;AAEJ;AAEI;EACE,YAAA;AAAN;AAIE;EACE,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,kCAAA;EACA,eAAA;AAFJ;AAII;EACE,oBAAA;AAFN;AAOI;EACE,YAAA;AALN;AASE;EACE,WAAA;AAPJ;AAcE;EACE,cAAA;EACA,WAAA;AAZJ;AAeE;EACE,yDAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAbJ;AAgBE;EACE,kBAAA;AAdJ;AAiBE;EACE,mBAAA;AAfJ;AAkBE;EACE,YAAA;AAhBJ;AAmBE;EACE,gBAAA;EACA,cAAA;EACA,uBAAA;AAjBJ;AAmBI;EACE,aAAA;AAjBN;AAqBE;EACE,qBAAA;EACA,mBAAA;EACA,mBAAA;AAnBJ;AAsBE;EACE,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AApBJ;AAsBI;EACE,yBAAA;AApBN;AAwBE;EACE,gBAAA;EACA,wBAAA;AAtBJ;AAyBE;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oCAAA;EACA,sBAAA;EACA,4BAAA;AAvBJ;AAyBI;EACE,eAAA;EACA,yBAAA;AAvBN;AA2BE;EACE,2BAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;EACA,8BAAA;EACA,iCAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;AA1BJ;AA6BE;EACE,8BAAA;EACA,2BAAA;AA3BJ;AA8BE;EACE,+BAAA;EACA,4BAAA;AA5BJ;AA+BE;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AA7BJ;AA+BI;EACE,mCAAA;EACA,8BAAA;EACA,cAAA;AA7BN;AAgCI;EACE,aAAA;AA9BN;AAiCI;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AA/BN;AAmCE;EACE,mDAAA;EACA,6CAAA;AAjCJ;AAoCE;EACE,uBAAA;EACA,kBAAA;AAlCJ;AAqCE;EACE,sBAAA;AAnCJ;AAsCE;EACE,sBAAA;EACA,iBAAA;AApCJ;AAuCE;EAKE,gCAAA;AArCJ;AAwCE;EACE,WAAA;EAEA,oCAAA;AAvCJ;AAyCI;EACE,wBAAA;AAvCN;AA2CE;EACE,gBAAA;EACA,iBAAA;AAzCJ;AA4CE;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;AA1CJ;AA6CE;EACE,kBAAA;AA3CJ;AA6CI;EACE,SAAA;EACA,yBAAA;AA3CN;AA8CI;EACE,uBAAA;EACA,QAAA;AA5CN;AA+CI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,uBAAA;EACA,kBAAA;AA7CN;AAgDI;EACE,aAAA;AA9CN;AAkDE;EACE,qBAAA;EACA,mBAAA;AAhDJ","sourcesContent":[":host {\r\n  display: block;\r\n  width: 95%;\r\n  margin-bottom: 10px;\r\n\r\n  .q-icon {\r\n    font-style: normal;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .q-remove-icon {\r\n    &::before {\r\n      content: '❌'\r\n    }\r\n  }\r\n\r\n  .q-arrow-icon-button {\r\n    float: left;\r\n    margin: 4px 6px 4px 0;\r\n    transform: rotate(90deg);\r\n    transition: linear 0.25s transform;\r\n    cursor: pointer;\r\n\r\n    &.q-collapsed {\r\n      transform: rotate(0);\r\n    }\r\n  }\r\n\r\n  .q-arrow-icon {\r\n    &::before {\r\n      content: '▶'\r\n    }\r\n  }\r\n\r\n  .q-add-icon {\r\n    color: #555;\r\n\r\n    &::before {\r\n      //content: '➕'\r\n    }\r\n  }\r\n\r\n  .q-remove-button {\r\n    color: #B3415D;\r\n    width: 31px;\r\n  }\r\n\r\n  .q-switch-group, .q-button-group {\r\n    font-family: \"Lucida Grande\", Tahoma, Verdana, sans-serif;\r\n    overflow: hidden;\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n  }\r\n\r\n  .q-switch-group {\r\n    padding-left: 20px;\r\n  }\r\n\r\n  .q-button-group {\r\n    padding-right: 20px;\r\n  }\r\n\r\n  .q-right-align {\r\n    float: right;\r\n  }\r\n\r\n  .q-button {\r\n    margin-left: 8px;\r\n    padding: 0 8px;\r\n    background-color: white;\r\n\r\n    &:disabled {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .q-control-size {\r\n    display: inline-block;\r\n    vertical-align: top;\r\n    padding-right: 10px;\r\n  }\r\n\r\n  .q-input-control, .q-operator-control, .q-field-control, .q-entity-control {\r\n    display: inline-block;\r\n    padding: 5px 8px;\r\n    color: #555;\r\n    background-color: #fff;\r\n    background-image: none;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    box-sizing: border-box;\r\n    width: auto;\r\n\r\n    &:disabled {\r\n      border-color: transparent;\r\n    }\r\n  }\r\n\r\n  .q-operator-control, .q-field-control, .q-entity-control, .q-input-control:not([type='checkbox']) {\r\n    min-height: 32px;\r\n    -webkit-appearance: none;\r\n  }\r\n\r\n  .q-switch-label, .q-button {\r\n    float: left;\r\n    margin-bottom: 0;\r\n    font-size: 8px;\r\n    line-height: 21px;\r\n    font-weight: normal;\r\n    text-align: center;\r\n    text-shadow: none;\r\n    border: 1px solid rgba(0, 0, 0, 0.2);\r\n    box-sizing: border-box;\r\n    font-family: 'robotoregular';\r\n\r\n    &:hover {\r\n      cursor: pointer;\r\n      background-color: #F0F0F0;\r\n    }\r\n  }\r\n\r\n  .q-button {\r\n    font-weight: 600 !important;\r\n    text-transform: uppercase;\r\n    font-stretch: normal;\r\n    font-style: normal;\r\n    line-height: normal !important;\r\n    letter-spacing: normal !important;\r\n    color: #282828 !important;\r\n    border-radius: 3px !important;\r\n    border: solid 1px #e5eaed !important;\r\n    padding-bottom: 2px;\r\n  }\r\n\r\n  .q-switch-label {\r\n    background-color: #e5eaed;\r\n    padding: 0 8px;\r\n    height: 21px;\r\n    color: #81898c;\r\n  }\r\n\r\n  .q-switch-label-and {\r\n    border-bottom-left-radius: 3px;\r\n    border-top-left-radius: 3px;\r\n  }\r\n\r\n  .q-switch-label-or {\r\n    border-bottom-right-radius: 3px;\r\n    border-top-right-radius: 3px;\r\n  }\r\n\r\n  .q-switch-radio {\r\n    position: absolute;\r\n    clip: rect(0, 0, 0, 0);\r\n    height: 1px;\r\n    width: 1px;\r\n    border: 0;\r\n    overflow: hidden;\r\n\r\n    &:checked + .q-switch-label {\r\n      border: 1px solid rgb(97, 158, 215);\r\n      background: #1873b1 !important;\r\n      color: #ffffff;\r\n    }\r\n\r\n    &:disabled + .q-switch-label {\r\n      display: none;\r\n    }\r\n\r\n    &:checked:disabled + .q-switch-label {\r\n      display: initial;\r\n      color: initial;\r\n      cursor: default;\r\n      border-color: transparent;\r\n    }\r\n  }\r\n\r\n  .q-invalid-ruleset {\r\n    border: 1px solid rgba(179, 65, 93, 0.5) !important;\r\n    background: rgba(179, 65, 93, 0.1) !important;\r\n  }\r\n\r\n  .q-empty-warning {\r\n    color: rgb(141, 37, 46);\r\n    text-align: center;\r\n  }\r\n\r\n  .q-ruleset {\r\n    border: 1px solid #CCC;\r\n  }\r\n\r\n  .q-rule {\r\n    border: 1px solid #CCC;\r\n    background: white;\r\n  }\r\n\r\n  .q-transition {\r\n    -webkit-transition: all 0.1s ease-in-out;\r\n    -moz-transition: all 0.1s ease-in-out;\r\n    -ms-transition: all 0.1s ease-in-out;\r\n    -o-transition: all 0.1s ease-in-out;\r\n    transition: all 0.1s ease-in-out;\r\n  }\r\n\r\n  .q-tree-container {\r\n    width: 100%;\r\n    //overflow: hidden;\r\n    transition: ease-in 0.25s max-height;\r\n\r\n    &.q-collapsed {\r\n      max-height: 0 !important;\r\n    }\r\n  }\r\n\r\n  .q-tree {\r\n    list-style: none;\r\n    margin: 4px 0 2px;\r\n  }\r\n\r\n  .q-row {\r\n    padding: 6px 8px;\r\n    margin-top: 6px;\r\n    border-radius: 3px;\r\n    border: solid 1px #e5eaed;\r\n    width: 90%;\r\n    margin-left: 5%;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .q-connector {\r\n    position: relative;\r\n\r\n    &::before {\r\n      top: -5px;\r\n      border-width: 0 0 2px 2px;\r\n    }\r\n\r\n    &::after {\r\n      border-width: 0 0 0 2px;\r\n      top: 50%;\r\n    }\r\n\r\n    &::before, &::after {\r\n      content: '';\r\n      left: -12px;\r\n      border-color: #CCC;\r\n      border-style: solid;\r\n      width: 9px;\r\n      height: calc(50% + 6px);\r\n      position: absolute;\r\n    }\r\n\r\n    &:last-child::after {\r\n      content: none;\r\n    }\r\n  }\r\n\r\n  .q-inline-block-display {\r\n    display: inline-block;\r\n    vertical-align: top;\r\n  }    \r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
